/* Official 2355 Riotball league registry — single source of truth for the
   roster grid, team dossier pages, and the franchise picker.
   Emblem plates live in /public/assets: team-logo-<id>.png (current crest)
   and team-logo-<id>-mk1.png (founding-era crest replica). */

export const riotballTeams = [
  {
    id: "red-force",
    name: "RED FORCE",
    tag: "THE PROTESTERS' RESILIENCE",
    record: "CHAMPIONS — 2350 FINAL",
    style: "Born from the League of the Fallen. Full-court collisions, zero retreat, engine noise as a weapon.",
    alt: "Red Force raised fist and lightning emblem",
    color: "#ff2d46",
    founded: "2035",
    home: "SECTOR 9 ZONES — THE AL RIOTBALL ARENA",
    lore: "The original. Red Force carries the stain of the defaced ball from the Night of the Shattered Concrete — the five fallen are painted inside the arena tunnel, and every player touches the names on the way out. Fifteen years of Dolo made them the people's team; his decommissioning made them something angrier.",
    players: [
      { unit: "UNIT 07", name: "THE ENFORCER", position: "CORE CARRIER", note: "Servo-actuator pistons in both legs. Leads the league in broken barricades and broken ribs." },
      { unit: "UNIT 09", name: "THE SCYTHE", position: "STRIKER", note: "Cuts lanes no schematic admits exist. Fastest forty-yard in the 2355 combine." },
      { unit: "UNIT 03", name: "THE WALL", position: "DEFENDER", note: "Plated like a blockade door. Has not been moved off a mark since 2352." },
      { unit: "UNIT 05", name: "THE OVERMIND", position: "PLAYCALLER", note: "Reads the arena three plays deep. Rumored to run a salvaged tactical cortex." },
      { unit: "UNIT 11", name: "THE STRIKER", position: "CORE CARRIER", note: "Rookie of the 2355 season. Wears number 11 for the eleven who fell at the Capitol steps." },
    ],
    seasons: [
      { year: "2350", result: "CHAMPIONS", note: "Won the Final and lost Dolo the same night. The trophy is engraved; the record book is not." },
      { year: "2352", result: "RUNNERS-UP", note: "Dropped the Final to the Guard by a single Core in a match the city still argues about." },
      { year: "2355", result: "1ST — TOUR LEADERS", note: "Undefeated through the dust swing. The Final rematch is already sold out twice over." },
    ],
    emblemHistory: [
      {
        era: "MK-I — THE STAINED BALL",
        year: "2035",
        text: "No crest existed at the founding — only the defaced soccer ball, stained red on the Capitol lawn. Survivors pressed handprints beside it. The league archive holds the only print.",
        image: null,
      },
      {
        era: "MK-II — THE RAISED FIST",
        year: "2041",
        text: "When the League of the Fallen went professional, the fist-and-lightning mark was spray-cut from a blockade stencil. Replicas of the founding plate still hang in Sector 9 locker rooms.",
        image: "/assets/team-logo-red-force-mk1.png",
      },
      {
        era: "MK-III — CURRENT CREST",
        year: "2350",
        text: "Reforged in polished alloy after the championship — the only crest in the league the Alliance never managed to sterilize.",
        image: "/assets/team-logo-red-force.png",
      },
    ],
  },
  {
    id: "white-guards",
    name: "WHITE GUARDS",
    tag: "THE LEAGUE'S OPPRESSION",
    record: "CORPORATE REBUILD — 2355 ROSTER",
    style: "Pristine white armor, perfect formation discipline. Nobody scores on the Guard twice in one quarter.",
    alt: "White Guards shield and cross emblem",
    color: "#e8e8f0",
    founded: "2044",
    home: "CAPITOL DOME — NEW ARCADIA",
    lore: "Founded by the Alliance League as the official answer to the riot — Shock Trooper tryouts, corporate sponsors, a dress code written into the rulebook. The Guards play like the law reads: cold, exact, and entirely without apology.",
    players: [
      { unit: "UNIT 01", name: "THE CONSTABLE", position: "PLAYCALLER", note: "Chief Constable's personal pick. Calls plays in regulation order codes." },
      { unit: "UNIT 22", name: "PHALANX", position: "DEFENDER", note: "Anchors the white wall. Opposing carriers describe the hit as 'being arrested at speed.'" },
      { unit: "UNIT 14", name: "LONGBOW", position: "STRIKER", note: "Highest scoring arm in corporate ball — throws the Core like a verdict." },
      { unit: "UNIT 08", name: "CENSOR", position: "CORE CARRIER", note: "Erases highlight reels of anyone who jukes him. None exist." },
      { unit: "UNIT 19", name: "PROTOCOL", position: "UTILITY", note: "Has never committed a penalty. Has caused hundreds." },
    ],
    seasons: [
      { year: "2350", result: "FINALISTS", note: "Lost the Final to Red Force and filed three formal protests. All three were denied by their own league." },
      { year: "2352", result: "CHAMPIONS", note: "Took the rematch by one Core. The parade route was fenced." },
      { year: "2355", result: "2ND — REBUILD", note: "Half the roster rotated out for younger chassis. The discipline remains; the mercy never existed." },
    ],
    emblemHistory: [
      {
        era: "MK-I — THE REGULATION SHIELD",
        year: "2044",
        text: "Issued, not designed — the founding shield was stamped from the same plate as Shock Trooper insignia, cross and all. The founding plate survives in the Capitol Dome trophy corridor.",
        image: "/assets/team-logo-white-guards-mk1.png",
      },
      {
        era: "MK-II — CURRENT CREST",
        year: "2352",
        text: "Cleaned and chromed after the championship. The cross was sharpened; the message was not softened.",
        image: "/assets/team-logo-white-guards.png",
      },
    ],
  },
  {
    id: "obsidian-legion",
    name: "OBSIDIAN LEGION",
    tag: "THE SERPENT ORDER",
    record: "PROMOTED — 2354 WILDCARD",
    style: "Coiled defense that strikes on the turnover. The Legion never chases the Core — it waits for you to carry it in.",
    alt: "Obsidian Legion coiled serpent shield emblem",
    color: "#8f6fd8",
    founded: "2349",
    home: "THE COIL — IRRADIATED SUBWAY DEPTH 3",
    lore: "Grown in the same flooded tunnels that hid the illegal matches, the Legion treats defense as a religion. Their arena has no floodlights — the crowd watches by flare and headlamp, and visiting teams swear the floor moves.",
    players: [
      { unit: "UNIT 13", name: "CONSTRICTOR", position: "DEFENDER", note: "Wraps carriers and squeezes the play dead. League-most forced fumbles, 2354." },
      { unit: "UNIT 66", name: "VENOM", position: "STRIKER", note: "Scores exclusively off turnovers. Has never taken a set play." },
      { unit: "UNIT 31", name: "SHED", position: "CORE CARRIER", note: "Slips contact like wet glass. Tacklers finish plays holding nothing." },
      { unit: "UNIT 02", name: "THE COIL", position: "PLAYCALLER", note: "Runs the slowest offense on tour and the most suffocating." },
      { unit: "UNIT 47", name: "FANG", position: "UTILITY", note: "Specialist in the last thirty seconds. Two playoff daggers already." },
    ],
    seasons: [
      { year: "2349", result: "FOUNDED — DEPTH LEAGUE", note: "Went unbeaten through the unlicensed tunnel circuit before the league was forced to notice." },
      { year: "2354", result: "WILDCARD PROMOTION", note: "Strangled three corporate rosters in the qualifier. Conceded eleven Cores all season." },
      { year: "2355", result: "4TH — COILED", note: "Nobody wants the Legion in the playoff bracket. Everybody will get them." },
    ],
    emblemHistory: [
      {
        era: "MK-I — THE TUNNEL MARK",
        year: "2349",
        text: "The coiled serpent was first chalked on Depth 3 tunnel walls to mark safe passage to illegal matches. The founding plate keeps the chalk-line roughness on purpose.",
        image: "/assets/team-logo-obsidian-legion-mk1.png",
      },
      {
        era: "MK-II — CURRENT CREST",
        year: "2354",
        text: "Cast in black glass on promotion. The serpent's eye was left unpolished — 'a coil never shows its shine.'" ,
        image: "/assets/team-logo-obsidian-legion.png",
      },
    ],
  },
  {
    id: "chrome-phantoms",
    name: "CHROME PHANTOMS",
    tag: "THE GHOST PROTOCOL",
    record: "MID-SEASON CLIMB — 2355",
    style: "Hologram rotations and decoy runners. Half the Phantom lineup isn't where your eyes say it is.",
    alt: "Chrome Phantoms glowing ghost emblem",
    color: "#7fd8ff",
    founded: "2351",
    home: "MIRAGE FIELD — SECTOR 12 RELAY SPIRE",
    lore: "A Black-Ops Net experiment that went commercial: projection tech stolen from drone decoys, bolted onto athletes. The league legalized their hologram rotations after nine months of argument — mostly because no official could prove which rule it broke.",
    players: [
      { unit: "UNIT 00", name: "GHOST-IMAGE", position: "CORE CARRIER", note: "Carries the real Core. Usually. Even teammates check twice." },
      { unit: "UNIT 17", name: "STATIC", position: "STRIKER", note: "Scores during opponent challenge reviews. Leads the league in unreviewed points." },
      { unit: "UNIT 23", name: "AFTERBURN", position: "UTILITY", note: "Leaves a light-trail defenders follow into walls. It's considered a legitimate tactic now." },
      { unit: "UNIT 55", name: "THE DECOY", position: "DEFENDER", note: "Officially listed at two positions simultaneously. The paperwork gave up." },
      { unit: "UNIT 39", name: "SIGNAL-LOST", position: "PLAYCALLER", note: "Calls plays on a frequency the broadcast can't catch. Neither can referees." },
    ],
    seasons: [
      { year: "2351", result: "EXPANSION — 12TH", note: "Lost every away game; nobody's cameras could calibrate. Won every home game." },
      { year: "2354", result: "9TH — PROTOCOL BANNED, THEN UNBANNED", note: "The decoy ruling swung their season twice. They keep the hearing transcripts framed." },
      { year: "2355", result: "5TH — CLIMBING", note: "Mid-season surge. Opponents now train against projectors. It doesn't help." },
    ],
    emblemHistory: [
      {
        era: "MK-I — THE DEAD PIXEL",
        year: "2351",
        text: "The founding ghost was a single corrupted frame pulled from a crashed drone feed — half-rendered, cyan, gone if you looked straight at it. The founding plate reprints that exact frame.",
        image: "/assets/team-logo-chrome-phantoms-mk1.png",
      },
      {
        era: "MK-II — CURRENT CREST",
        year: "2354",
        text: "Rebuilt as a stable hologram master. It still flickers once per minute. The league timed it; the Phantoms deny everything.",
        image: "/assets/team-logo-chrome-phantoms.png",
      },
    ],
  },
  {
    id: "verdigris-vanguard",
    name: "VERDIGRIS VANGUARD",
    tag: "THE MACHINE BLOOM",
    record: "EXPANSION FRANCHISE — 2355",
    style: "Oxidized armor grown over living circuits. The Vanguard grinds in slow gears and never stops turning.",
    alt: "Verdigris Vanguard gear emblem",
    color: "#4fd8a8",
    founded: "2355",
    home: "THE GREENWORKS — OLD ATLANTA REACTOR RING",
    lore: "The youngest franchise on tour, grown — literally — in the Reactor Ring hydroponic machine bays. Their armor oxidizes green as the season wears on; rookies shine copper, veterans bloom full verdigris. You can read a Vanguard career off their plating.",
    players: [
      { unit: "UNIT 88", name: "FLYWHEEL", position: "DEFENDER", note: "Starts slow, never stops. Fourth-quarter Vanguard is a different sport." },
      { unit: "UNIT 60", name: "COPPERBLOOM", position: "CORE CARRIER", note: "Rookie chassis still shining. The bloom is coming; the league is warned." },
      { unit: "UNIT 71", name: "GEARWORK", position: "PLAYCALLER", note: "Oldest active player on tour. His plating hasn't been bare copper since 2341." },
      { unit: "UNIT 26", name: "ROOTSTOCK", position: "UTILITY", note: "Grew up in the Reactor Ring bays. Literally — his chassis serial is a batch number." },
      { unit: "UNIT 94", name: "OXIDE", position: "STRIKER", note: "Scores grinding, ugly, inevitable Cores. Zero highlights, fifty-nine points." },
    ],
    seasons: [
      { year: "2355", result: "EXPANSION — 8TH", note: "First season on tour. Took the Silverbacks to overtime in week one and the league has been polite ever since." },
    ],
    emblemHistory: [
      {
        era: "MK-I — THE BARE COG",
        year: "2355",
        text: "Stamped in raw copper at the franchise's founding — the only team whose founding plate is newer than its players' scars. It will oxidize in the archive, by design.",
        image: "/assets/team-logo-verdigris-vanguard-mk1.png",
      },
      {
        era: "MK-II — CURRENT CREST",
        year: "2355",
        text: "The same cog, bloomed green. The Vanguard refuses to seal it: 'the crest ages with the team. That's the point.'",
        image: "/assets/team-logo-verdigris-vanguard.png",
      },
    ],
  },
  {
    id: "night-ravens",
    name: "NIGHT RAVENS",
    tag: "THE CARRION CIRCUIT",
    record: "DARK HORSE — 2354 SEASON",
    style: "Night-shift flyers circling every broken play and picking it clean. Loudest wings in the league.",
    alt: "Night Ravens spread-wing raven emblem",
    color: "#9a6bff",
    founded: "2347",
    home: "THE ROOST — ASH FALLS RELAY TOWERS",
    lore: "Scavenger-runners who turned pro when the league ran out of excuses. The Ravens train at night on live routes, dodging the same wildlife and worse that Wasteland Runners face. They don't win pretty. They win what's left.",
    players: [
      { unit: "UNIT 33", name: "CARRION", position: "STRIKER", note: "League leader in second-chance Cores. Feeds on broken plays exclusively." },
      { unit: "UNIT 44", name: "NIGHTWING", position: "CORE CARRIER", note: "Fastest player on tour under floodlight-off conditions. Trains by headlamp." },
      { unit: "UNIT 27", name: "THE ROOK", position: "DEFENDER", note: "Builds the nest at the defensive line. Nothing migrates through." },
      { unit: "UNIT 51", name: "BLACKFEATHER", position: "PLAYCALLER", note: "Ex-courier with eleven seasons of route memory. Sees lanes before they open." },
      { unit: "UNIT 68", name: "CIRCLER", position: "UTILITY", note: "Never stops moving. GPS tracking once logged him at 41 kilometers in a single match." },
    ],
    seasons: [
      { year: "2347", result: "FOUNDED — CIRCUIT", note: "Assembled from Ash Falls courier crews. Their first contract was written on a delivery manifest." },
      { year: "2354", result: "DARK HORSE — SEMIFINAL", note: "Picked the bracket clean to the semifinal as the tenth seed. The Ravens call it 'the good year'." },
      { year: "2355", result: "3RD — CIRCLING", note: "One game off the tour lead. The wings are loud again." },
    ],
    emblemHistory: [
      {
        era: "MK-I — THE TOWER MARK",
        year: "2347",
        text: "Courier crews tagged relay towers with a spread-wing stencil to claim roosting rights. The founding plate is traced from the last surviving tower tag at Ash Falls.",
        image: "/assets/team-logo-night-ravens-mk1.png",
      },
      {
        era: "MK-II — CURRENT CREST",
        year: "2354",
        text: "Re-cut for the semifinal run in deep purple alloy. The wings were spread wider — 'more sky to take.'",
        image: "/assets/team-logo-night-ravens.png",
      },
    ],
  },
  {
    id: "aurora-syndicate",
    name: "AURORA SYNDICATE",
    tag: "THE STATIC CARTEL",
    record: "CORPORATE TIER — 2355",
    style: "Linked nodes sharing one mind. The Syndicate passes before it moves — the Core just arrives.",
    alt: "Aurora Syndicate molecular network emblem",
    color: "#46e0d4",
    founded: "2350",
    home: "NODE SPIRE — NEW ARCADIA UPPER GRID",
    lore: "The corporate answer to team chemistry: five athletes on a shared neural link, bought at auction from a defunct military program. The Syndicate doesn't huddle. It syncs. The league limits the link to 'advisory bandwidth' — a rule nobody knows how to enforce.",
    players: [
      { unit: "NODE-1", name: "PRIME RELAY", position: "PLAYCALLER", note: "The hub of the link. His stat line is the whole team's assist column." },
      { unit: "NODE-2", name: "LATTICE", position: "CORE CARRIER", note: "Arrives at gaps 0.4 seconds before they exist. The league measured." },
      { unit: "NODE-3", name: "CASCADE", position: "STRIKER", note: "Catches passes nobody was seen throwing. Review protocol pending since 2353." },
      { unit: "NODE-4", name: "BASTION", position: "DEFENDER", note: "Slides to cover teammates' mistakes before they make them." },
      { unit: "NODE-5", name: "ECHO-LINK", position: "UTILITY", note: "The redundancy node. Plays every position in a single rotation." },
    ],
    seasons: [
      { year: "2350", result: "FOUNDED — AUCTION", note: "Bought as a unit from the Helix Program liquidation. The receipt is in the league museum." },
      { year: "2353", result: "RUNNERS-UP", note: "Lost the Final on a single desync — 0.2 seconds of static that cost a dynasty." },
      { year: "2355", result: "6TH — CORPORATE TIER", note: "Steady, synchronized, terrifying in stretches. The link hums louder every season." },
    ],
    emblemHistory: [
      {
        era: "MK-I — THE HELIX NODE",
        year: "2350",
        text: "Inherited wholesale from the military program — five nodes around a core, stamped on the auction lot itself. The founding plate is the original program seal, bought with the players.",
        image: "/assets/team-logo-aurora-syndicate-mk1.png",
      },
      {
        era: "MK-II — CURRENT CREST",
        year: "2353",
        text: "Re-drawn for broadcast after the Final run. Six nodes now — the sixth is unlisted. The Syndicate won't say why.",
        image: "/assets/team-logo-aurora-syndicate.png",
      },
    ],
  },
  {
    id: "iron-hearts",
    name: "IRON HEARTS",
    tag: "THE BROKEN VALENTINE",
    record: "REBUILD SEASON — 2355",
    style: "Riveted hearts, cracked but beating. Iron Hearts plays every down like the last one broke something.",
    alt: "Iron Hearts riveted cracked heart emblem",
    color: "#ff7d9c",
    founded: "2346",
    home: "THE FORGE — DUST RIDGES FOUNDRY DISTRICT",
    lore: "A foundry workers' team that lost its arena, its sponsor, and half its roster in the 2353 Ridge Collapse — and refused to fold. The league's sentimental favorite and its hardest out: nobody hits back like a team with nothing left to lose twice.",
    players: [
      { unit: "UNIT 45", name: "RIVET", position: "DEFENDER", note: "Holds the line the way the foundry held the roof — longer than physics suggested." },
      { unit: "UNIT 12", name: "VALENTINE", position: "CORE CARRIER", note: "Carries number 12 for the twelve lost in the Collapse. Their names are inside his chest plate." },
      { unit: "UNIT 77", name: "SLAG", position: "STRIKER", note: "Scores ugly and celebrates less. Leads the league in post-Core nods." },
      { unit: "UNIT 30", name: "THE ANVIL", position: "UTILITY", note: "Whatever breaks, he absorbs. Oldest knees on tour, loudest hit." },
      { unit: "UNIT 58", name: "EMBER", position: "PLAYCALLER", note: "Twenty years old, calls like a veteran. The rebuild is being built around her." },
    ],
    seasons: [
      { year: "2353", result: "RIDGE COLLAPSE — SEASON FORFEIT", note: "The Forge came down in week nine. The league offered a dissolution payout. The Hearts voted 4-0 to finish the schedule. They lost every game. Nobody counted." },
      { year: "2354", result: "9TH — RETURN", note: "Won their homecoming in the temporary pit arena. Longest standing ovation in league history: eleven minutes." },
      { year: "2355", result: "7TH — REBUILD", note: "Young roster, heavy hearts, mean streak. The Forge reopens next season." },
    ],
    emblemHistory: [
      {
        era: "MK-I — THE FOUNDRY STAMP",
        year: "2346",
        text: "The riveted heart began as the Foundry District makers' mark — pressed into every beam the district ever poured. The founding plate is stamped, not drawn, into cold steel.",
        image: "/assets/team-logo-iron-hearts-mk1.png",
      },
      {
        era: "MK-II — THE CRACK",
        year: "2353",
        text: "After the Collapse the team cracked the crest down the middle and riveted it back. The league offered a clean redesign. The Hearts declined in writing, one word: 'No.'",
        image: "/assets/team-logo-iron-hearts.png",
      },
    ],
  },
  {
    id: "voltaic-vultures",
    name: "VOLTAIC VULTURES",
    tag: "THE STORM SCAVENGERS",
    record: "SHOCK DIVISION — 2354",
    style: "They circle the lightning. Voltaic dives on every loose Core before it stops sparking.",
    alt: "Voltaic Vultures vulture and lightning bolt emblem",
    color: "#ffd84d",
    founded: "2348",
    home: "THE SPARK GAP — STATIC LINE RIDGE",
    lore: "Raised on the Static Line, where storms roll off the wastes and power is whatever you can catch. The Vultures ground their arena lightning rods through the visitors' bench — technically legal, spiritually devastating. Loose balls near them are a religious experience.",
    players: [
      { unit: "UNIT 21", name: "GROUNDWIRE", position: "DEFENDER", note: "Drains the play dead. Leads the league in recovered fumbles by an insulting margin." },
      { unit: "UNIT 36", name: "STORMCROW", position: "STRIKER", note: "Scores in bunches when the weather turns. The league schedules around forecasts now." },
      { unit: "UNIT 49", name: "ARC", position: "CORE CARRIER", note: "Runs routes shaped like lightning. Defenders describe covering him as 'being outdoors.'" },
      { unit: "UNIT 15", name: "THE CAPACITOR", position: "UTILITY", note: "Quiet for three quarters, discharges in the fourth. Holds the single-period scoring record." },
      { unit: "UNIT 62", name: "RIDGE RUNNER", position: "PLAYCALLER", note: "Calls the fastest tempo on tour. The huddle is a rumor." },
    ],
    seasons: [
      { year: "2348", result: "FOUNDED — STATIC LINE", note: "Founded by line workers who strung the ridge cables. Their first trophy was a confiscated storm battery." },
      { year: "2354", result: "SHOCK DIVISION WINNERS", note: "Won the division on a last-play diving recovery — the Core was still sparking when he crossed." },
      { year: "2355", result: "9TH — REGRESSION", note: "A dry season off the ridge. The storms are coming back. So are they." },
    ],
    emblemHistory: [
      {
        era: "MK-I — THE LINE CREW BOLT",
        year: "2348",
        text: "The vulture-and-bolt was the Static Line crew's hazard mark — spray it on a tower, the tower's yours to climb. The founding plate is cut from decommissioned cable alloy.",
        image: "/assets/team-logo-voltaic-vultures-mk1.png",
      },
      {
        era: "MK-II — CURRENT CREST",
        year: "2354",
        text: "Gilded after the division title. The gold is real; the crew melted down the confiscated battery to make it.",
        image: "/assets/team-logo-voltaic-vultures.png",
      },
    ],
  },
  {
    id: "silverbacks",
    name: "SILVERBACKS",
    tag: "THE CONCRETE JUNGLE",
    record: "HEAVYWEIGHT BRACKET — 2355",
    style: "Pure reach and raw mass. When the Silverbacks beat their chests, the arena answers.",
    alt: "Silverbacks roaring gorilla emblem",
    color: "#c0c8d8",
    founded: "2344",
    home: "THE YARD — CITY BLOCKADE WALLWORKS",
    lore: "Built from the wall-crews that raised the City Blockade, the Silverbacks are the heaviest roster ever certified — average chassis mass is a league record that will never fall, because they lobbied to cap it. Subtlety files a complaint and loses.",
    players: [
      { unit: "UNIT 99", name: "APEX", position: "DEFENDER", note: "Largest certified athlete in league history. The goal posts were reinforced because of him." },
      { unit: "UNIT 75", name: "CRUSH", position: "CORE CARRIER", note: "Doesn't dodge. Has never dodged. Film study suggests he doesn't know how." },
      { unit: "UNIT 81", name: "TREMOR", position: "UTILITY", note: "His pre-match chest beat registers on the seismic sensor in Depth 3." },
      { unit: "UNIT 53", name: "GREYBEARD", position: "PLAYCALLER", note: "Twelfth season. Calls three plays total. Nobody stops any of them." },
      { unit: "UNIT 40", name: "THE WALL-RAISER", position: "STRIKER", note: "Scored the heaviest Core ever recorded — 41 kilograms of carrier crossed the line with it." },
    ],
    seasons: [
      { year: "2344", result: "FOUNDED — WALLWORKS", note: "The wall-crews' company team went independent when the company folded. The players kept the name, the colors, and the cranes." },
      { year: "2351", result: "HEAVYWEIGHT BRACKET CHAMPIONS", note: "Won the inaugural heavyweight bracket without conceding a second-half Core." },
      { year: "2355", result: "10TH — HEAVYWEIGHT BRACKET", note: "A slow season by mass-market standards. Still the team no one schedules twice in a row." },
    ],
    emblemHistory: [
      {
        era: "MK-I — THE CREW PLATE",
        year: "2344",
        text: "The roaring head was the wall-crew's union plate, riveted to every crane on the Blockade build. The founding plate still carries rivet burn at the corners.",
        image: "/assets/team-logo-silverbacks-mk1.png",
      },
      {
        era: "MK-II — CURRENT CREST",
        year: "2351",
        text: "Reforged in brushed silver for the bracket title. It weighs nine kilograms. The league display case was reinforced. Twice.",
        image: "/assets/team-logo-silverbacks.png",
      },
    ],
  },
];

export const franchiseById = (id) => riotballTeams.find((t) => t.id === id) || null;
export const franchiseEmblem = (id) => (franchiseById(id) ? `/assets/team-logo-${id}.png` : null);
